/**
 * Created by root on 3/6/16.
 */

define(function (require) {

    var BaseController = require('web-agent-assets-js/BaseController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var BaseApiService = require('web-agent-utils/BaseApiService');

    var APPLICATION_TYPE = 'PredictiveDialerController';

    var PredictiveDialerController = BaseController.extend(function (options) {
        this.model = options.model;
        this.service = createService();
    });

    PredictiveDialerController.prototype.applicationType = APPLICATION_TYPE;

    PredictiveDialerController.prototype.getSkillsWaitTime = function (reqObj) {
        var self = this;
        if (!reqObj) {
            return onError(null, 'invalid request object.');
        }
        else {
            if (!reqObj.skills) {
                return onError(null, 'missing argument (skills) - no skills supplied for the request.');
            }

            var request = {
                callingFunction: 'getSkillsWaitTime',
                method: 'GET',
                success: onSuccess,
                error: onError
            };

            // we are maxing the skills query to 20 skills.
            // if we don't pass on the skills query we will get all skills.
            if(reqObj.skills.length <= 20){
                request.query = {
                    skills: reqObj.skills.join(',')
                };
            }

            this.service.sendRequest(request);
        }


        function onSuccess(response) {
            if (reqObj && typeof reqObj.success === 'function') {
                reqObj.success({data: response.body});
            }
        }

        function onError(err, message) {
            var errorData = err && err.body ? err.body : {
                error: {
                    message: message,
                    time: new Date(),
                    originalRequest: reqObj
                }
            };
            errorData = errorData.error ? errorData : {error: errorData};
            self.logger.error('', 'getSkillsWaitTime', errorData);
            if (reqObj && typeof reqObj.error === 'function') {
                reqObj.error(errorData);
            }
        }
    };

    function createService () {
        var serviceResource = agentLEManager.getLEUrlResolverApiResourcesService("PredictiveDialer");
        var serviceURL = serviceResource && serviceResource.Skills && serviceResource.Skills.url;
        if (serviceURL) {
            return BaseApiService.createInstance({
                domainUrl: agentLEManager.getLEUrlResolverGetUrl(serviceURL),
                postmessagePath: "/postmessage",
                serviceName: APPLICATION_TYPE
            });
        }
    }


    return PredictiveDialerController;

});
